/* eslint-disable @typescript-eslint/ban-ts-comment */
type dataLayer = {
  event?: string;
  click_text?: string;
  click_url?: string;
  page_title?: string;
  tile_name?: string;
  tile_position?: number;
  recipe_name?: string;
  user_id?: string;
  recipe_id?: string;
  list_name?: string;
  recipe_list_name?: string;
  product_name?: string;
  item_list_name?: string;
  offer_name?: string;
  offer_list_name?: string;
  offer_count?: string;
  gigyaID?: string;
  eventName?: string;
  offer_tag?: string;
  item_position?: number;
  item_name?: string;
  item_price?: string;
  pageName?: string;
  ecommerce?: {};
  popup_name?: string;
  item?: string;
  page_type?: string;
  page_heading?: string;
  recipe_url?: string;
  event_action?: string;
  event_category?: string;
  event_var?: string;
  recipe_meal_category?: string;
  button_trigger?: string;
 
 
};

/***
 * To add the Data Layer
 */
export const addDataLayer = ({
  event,
  click_text,
  gigyaID,
  click_url,
  page_title,
}: dataLayer) => {
  (window as any).dataLayer?.push({
    event: event,
    param1: click_text,
    param2: click_url,
    ...(gigyaID ? { gigyaID } : {}),
    param4: page_title,
  });
};

/***
 * To add the Data Layer in recipe and tiles
 */
export const addDataLayerTiles = ({
  event,
  tile_name,
  tile_position,
  page_title,
}: dataLayer) => {
  (window as any).dataLayer?.push({
    event: event,
    param1: tile_name,
    param2: tile_position,
    param3: page_title,
  });
};

export const addDataLayerProducts = ({
  event,
  tile_name,
  tile_position,
  page_title,
}: dataLayer) => {
  (window as any).dataLayer?.push({
    event: event,
    param1: tile_name,
    param2: tile_position,
    param4: page_title,
  });
};

export const addDataLayerOfRecipeToList = ({
  event,
  recipe_name,
  tile_name,
  list_name,
  page_title,
  recipe_id,
  recipe_list_name,
  item,
  user_id,
}: dataLayer) => {
  (window as any).dataLayer?.push({
    event,
    param1: recipe_name,
    param2: list_name,
    param3: recipe_list_name,
    param4: page_title,
    param5: item,
  });
};

export const addDataLayerProductsAddList = ({
  event,
  click_text,
  list_name,
  page_title,
}: dataLayer) => {
  (window as any).dataLayer?.push({
    event: event,
    param1: click_text,
    param2: list_name,
    param4: page_title,
  });
};

export const addDataLayerShareList = ({
  event,
  click_text,
  list_name,
  page_title,
}: dataLayer) => {
  (window as any).dataLayer.push({
    event: event,
    param1: click_text,
    param2: list_name,
    param4: page_title,
  });
};

export const addDataLayerProductToList = ({
  event,
  product_name,
  item_list_name,
  list_name,
  page_title,
  offer_tag,
}: dataLayer) => {
  (window as any).dataLayer.push({
    event: event,
    param1: product_name,
    param2: list_name,
    param3: item_list_name,
    param4: page_title,
    param5: offer_tag,
  });
};

export const dataLayerRemoveFormList = ({
  event,
  product_name,
  list_name,
  page_title,
  offer_tag,
  item_list_name,
}: dataLayer) => {
  (window as any).dataLayer.push({
    event: event,
    param1: product_name,
    param3: item_list_name,
    param4: page_title,
    param5: offer_tag,
  });
};

export const addDataLayerProductToFavourite = ({
  event,
  product_name,
  item_list_name,
  list_name,
  page_title,
  item,
}: dataLayer) => {
  //@ts-ignore
  dataLayer.push({
    event: event,
    param1: product_name,
    param2: list_name,
    param3: item_list_name,
    param4: page_title,
    param5: item,
  });
};
export const dataLayerOffers = ({
  event,
  offer_name,
  list_name,
  offer_list_name,
  page_title,
}: dataLayer) => {
  (window as any).dataLayer.push({
    event: event,
    param1: offer_name,
    param2: list_name,
    param3: offer_list_name,
    param4: page_title,
  });
};

export const dataLayeOfferView = ({
  event,
  offer_count,
  offer_list_name,
  page_title,
  offer_tag,
}: dataLayer) => {
  (window as any).dataLayer.push({
    event: event,
    param1: offer_count,
    param3: offer_list_name,
    param4: page_title,
    param5: offer_tag,
  });
};

export const dataLayerArticleToRecipe = ({
  event,
  click_text,
  click_url,
  page_title,
  pageName,
}: dataLayer) => {
  (window as any).dataLayer.push({
    event: event,
    param1: click_text,
    param2: click_url,
    param4: page_title,
    param5: pageName,
  });
};

export const dataLayerShareWithFriend = ({
  event,
  recipe_name,
  eventName,
  page_title,
  item,
}: dataLayer) => {
  (window as any).dataLayer.push({
    event: event,
    param1: recipe_name,
    param2: eventName,
    param4: page_title,
    param5: item,
  });
};

export const addDataLayerProductClick = ({
  event,
  item_name,
  item_position,
  page_title,
}: dataLayer) => {
  //@ts-ignore
  dataLayer.push({
    event: event,
    param1: item_name,
    param2: item_position,
    param4: page_title,
  });
};

export const addDataLayerProductView = ({
  event,
  item_name,
  item_price,
  page_title,
}: dataLayer) => {
  //@ts-ignore
  dataLayer.push({
    event: event,
    param1: item_name,
    param2: item_price,
    param4: page_title,
  });
};

export const dataLayerProductViewList = ({ event, ecommerce }: dataLayer) => {
  (window as any).dataLayer.push({
    event: event,
    ecommerce: ecommerce,
  });
};

export const dataLayerProductSelectList = ({ event, ecommerce }: dataLayer) => {
  (window as any).dataLayer.push({
    event: event,
    ecommerce: ecommerce,
  });
};

export const dataLayerVoilaButton = ({
  event,
  click_text,
  click_url,
  page_title,
}: dataLayer) => {
  //@ts-ignore
  dataLayer.push({
    event: event,
    param1: click_text,
    param2: click_url,
    param4: page_title,
  });
};

export const addDataLayerPersistantbanner = ({
  event,
  popup_name,
}: dataLayer) => {
  (window as any).dataLayer?.push({
    event: event,
    param1: popup_name,
  });
};
export const addRecipeToMealPlan = ({
  event,
  recipe_name,
  recipe_url,
  recipe_meal_category,
  page_title,
}: dataLayer) => {
  (window as any).dataLayer?.push({
    event,
    param1: recipe_name,
    param2: recipe_url,
    param3: recipe_meal_category,
    param4: page_title,
  });
};

export const printMealPlan = ({
  event,
  click_text,
  click_url,
  page_title,
  page_heading,
}: dataLayer) => {
  (window as any).dataLayer?.push({
    event,
    param1: click_text,
    param2: click_url,
    param4: page_title,
    param5: page_heading,
  });
};

export const shareMealPlan = ({
  event,
  click_text,
  click_url,
  page_title,
  page_heading,
}: dataLayer) => {
  (window as any).dataLayer?.push({
    event,
    param1: click_text,
    param2: click_url,
    param4: page_title,
    param5: page_heading,
  });
};

export const substitueProduct = ({
  event,
  event_action,
  event_category,
  event_var,
}: dataLayer) => {
  (window as any).dataLayer?.push({
    event,
    event_action,
    event_category,
    event_var,
  });
};

export const addDataLayerRecipeAddList = ({
  event,
  click_text,
  list_name,
  page_title,
  page_type,
}: dataLayer) => {
  (window as any).dataLayer?.push({
    event: event,
    param1: click_text,
    param2: list_name,
    param4: page_title,
    param5: page_type,
  });
};

export const printRecipeDetails = ({
  event,
  recipe_name,
  button_trigger,
  page_title,
  page_heading,
}: dataLayer) => {
  (window as any).dataLayer?.push({
    event,
    param1: recipe_name,
    param2: button_trigger,
    param4: page_title,
    param5: page_heading,
  });
};